import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="app-container">
      <h1 style={{ color: "#ff6c00" }}>404</h1>
      <p>Page not found.</p>
      <Link to="/" style={{ color: "#ffa600" }}>Back to Home</Link>
    </div>
  );
}
